var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticStyle:{"width":"100%","display":"block"},attrs:{"src":_vm.videoSrc,"loop":"false","playsinline":"","poster":_vm.imgSrc,"muted":"false","direction":"0","controls":""},domProps:{"muted":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }